import { useState } from "react";
import { PageTabs } from "./PageTabs";

export default { title: "CatalogIndex/PageTabs", component: PageTabs };

export const ActiveArchived = () => {
  const [tab, setTab] = useState("active");
  return (
    <PageTabs
      activeKey={tab}
      onSelect={setTab}
      tabs={[
        { key: "active", label: "Active", count: 12 },
        { key: "archived", label: "Archived", count: 3 },
      ]}
    />
  );
};

export const ThreeContentTabs = () => {
  const [tab, setTab] = useState("technical");
  return (
    <PageTabs
      activeKey={tab}
      onSelect={setTab}
      tabs={[
        { key: "technical", label: "Technical Approval", count: 5 },
        { key: "sales", label: "Sales Approval" },
        { key: "business", label: "Business Approval" },
      ]}
    />
  );
};

export const NoCounts = () => {
  const [tab, setTab] = useState("active");
  return (
    <PageTabs
      activeKey={tab}
      onSelect={setTab}
      tabs={[
        { key: "active", label: "Active" },
        { key: "archived", label: "Archived" },
      ]}
    />
  );
};
